import { Component, Input, OnChanges } from '@angular/core';
import { Activity, Achievement } from '../models';
import { DatePipe } from '@angular/common';
import { DataService } from '../../services/data.service';


@Component({
  selector: 'app-strava-card',
  templateUrl: './strava-card.component.html',
  styleUrls: ['./strava-card.component.scss'],
  providers: [DatePipe],
})
export class StravaCardComponent implements OnChanges {
  @Input() activity: Activity;
  @Input() dark = false;
  @Input() full = true;
  @Input() showTitle = true;
  profilePhoto =
    localStorage?.getItem('profilePhoto') ?? '/assets/images/logo.png';
  athlete;
  label;
  hasLocation = false;
  achievements = [];
  limitedAchievements = [];
  constructor(private datePipe: DatePipe, private dataService: DataService) {}

  ngOnChanges() {
    if (this.activity.achievements) {
    this.achievements = this.sortItems(
      this.activity.achievements.concat(this.activity.segments ?? [])
    );
    this.limitedAchievements = [...this.achievements];

    }
    this.athlete = JSON.parse(localStorage?.getItem('athlete'));
    if (
      this.full &&
      this.activity &&
      this.activity.start_latlng?.[0] &&
      this.activity.start_latlng?.[1]
    ) {
      this.getLocation();
    } else {
      this.hasLocation = false;
      this.generateLabel();
    }
  }

  getLocation() {
    this.dataService
      .getLocation(this.activity.start_latlng[1], this.activity.start_latlng[0])
      .subscribe(
        (res) => {
          this.activity.location = {
            neighbourhood: res.address.neighbourhood,
            city: res.name ? res.name : res.address.town,
            country: res.address.country,
          };
          this.hasLocation = true;
          this.generateLabel();
        },
        () => {
          this.hasLocation = false;
          this.generateLabel();
        }
      );
  }

  generateLabel() {
    const today = new Date();
    const activityDate = new Date(this.activity.start_date_local);
    const isToday =
      today.setHours(0, 0, 0, 0) === activityDate.setHours(0, 0, 0, 0);
    let location;
    if (this.activity.location?.city && this.activity.location?.country) {
      location =
        this.activity.location.city + ' ' + this.activity.location.country;
    }
    if (this.activity.location?.city && !this.activity.location?.country) {
      location = this.activity.location.city;
    }
    if (!this.activity.location?.city && this.activity.location?.country) {
      location = this.activity.location.country;
    }
    if (isToday) {
      this.label = location
        ? 'Today, ' +
          this.datePipe.transform(
            new Date(this.activity.start_date_local),
            'HH:mm'
          ) +
          ' • ' +
          location
        : 'Today, ' +
          this.datePipe.transform(
            new Date(this.activity.start_date_local),
            'HH:mm'
          );
    } else {
      this.label = location
        ? this.datePipe.transform(
            new Date(this.activity.start_date_local),
            'MMM d, y, HH:mm'
          ) +
          ' • ' +
          location
        : this.datePipe.transform(
            new Date(this.activity.start_date_local),
            'MMM d, y, HH:mm'
          );
    }
  }

  private sortItems(items: Achievement[]): Achievement[] {
    const typeOrder: Record<string, number> = {
      overall: 0,
      segment_effort_count_leader: 1,
      pr: 2,
    };
    return items.sort((a, b) => {
      // First, sort by type using the predefined order
      const typeComparison = typeOrder[a.type] - typeOrder[b.type];
      if (typeComparison !== 0) {
        return typeComparison;
      }

      // If types are the same, sort by rank
      return a.rank - b.rank;
    });
  }
}
